import { Klydo, SoundMode } from '../api/klydo';

export type CollectionProfile = {
  hasChime: boolean;
  hasAlarm: boolean;
  soundMode: SoundMode;
};

const profileOf = (klydo: Klydo): CollectionProfile => ({
  hasChime: (klydo.chimesUrls?.length ?? 0) > 0,
  hasAlarm: (klydo.alarmUrls?.length ?? 0) > 0,
  soundMode: klydo.capabilitiesV2?.animationSound?.mode ?? SoundMode.OFF,
});

// A deleted klydo leaves a null entry, despite what the type says.
export const getCollectionProfile = (
  klydos: (Klydo | null)[],
): CollectionProfile | null => {
  const ref = klydos.find((klydo): klydo is Klydo => !!klydo);
  return ref ? profileOf(ref) : null;
};

export const isKlydoCompatibleWithCollection = (
  klydo: Klydo,
  profile: CollectionProfile,
): boolean => {
  const klydoProfile = profileOf(klydo);
  return (
    klydoProfile.hasChime === profile.hasChime &&
    klydoProfile.hasAlarm === profile.hasAlarm &&
    klydoProfile.soundMode === profile.soundMode
  );
};
